import {Component, Input, OnInit} from '@angular/core';
import {CardConfig} from '@shared/module/card/model';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-card-status',
  templateUrl: './card-status.component.html',
  styleUrls: ['./card-status.component.scss']
})
export class CardStatusComponent implements OnInit {
  @Input() config?: CardConfig;
  @Input() formGroup!: FormGroup;

  statusConfig!: CardConfig;

  constructor() {
  }

  ngOnInit(): void {
    if (this.config) {
      this.statusConfig = this.config;
    } else {
      this.statusConfig = {
        headerConfig: {
          title: {label: 'common.card.status.title'},
          icon: 'fa-regular fa-sliders-simple'
        },
        css: 'p-xlarge',
      };
    }
  }
}
